export const ConfigMantenedorDteExportacion = {
	barraBusqueda: {
		criterios: ["Razon Social", "Folio", "Track Id"],
		criteriosKeys: ["razonSocial", "folio", "trackId"],
		criterioPrincipal: "Razon Social",
		filiales: [] as any[],
		datePicker: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Facturación Exportación Emitida",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
